import type { FullLocation } from 'ts/types';
import { MutableRefObject, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { currentLocationFormattedAddressSelector } from 'redux/selectors/caseCreation';
import type { UseLocationParams } from './types';

const useAutocomplete = (params?: UseLocationParams) => {
  const selectedLocationFormattedAddress = useSelector(
    currentLocationFormattedAddressSelector,
  );

  const ref = useRef<any>() as MutableRefObject<HTMLInputElement>;
  const [options, setOptions] = useState<FullLocation[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState(() =>
    params?.avoidInitialization ? '' : selectedLocationFormattedAddress,
  );

  const setOnFocus = () => {
    ref?.current?.focus();
  };

  const handleOptionSelected = () => {
    setOptions([]);
  };

  const clearField = () => {
    setOnFocus();
    setInputValue('');
  };

  return {
    clearField,
    handleOptionSelected,
    inputValue,
    loading,
    options,
    ref,
    setInputValue,
    setLoading,
    setOnFocus,
    setOptions,
  };
};

export default useAutocomplete;
